import { useEffect, useState } from "react";

export const adminNavGroups = [
  {
    title: "Overview",
    items: [
      ["overview", "Dashboard"],
      ["service-status", "Service Status"],
    ],
  },
  {
    title: "Customers & orders",
    items: [
      ["customers", "Customers"],
      ["inbox", "Service inquiries"],
      ["orders", "Service orders"],
      ["ports", "Port requests"],
      ["messages", "Account messages"],
    ],
  },
  {
    title: "Phone services",
    items: [
      ["numbers", "Numbers"],
      ["devices", "Equipment"],
      ["feature-list", "Features List"],
      ["voice", "Voice studio"],
      ["time-temperature", "Time & Temperature"],
      ["experiences", "Add-ons"],
    ],
  },
  {
    title: "Plans & billing",
    items: [
      ["plans", "Service plans"],
      ["billing", "Billing"],
    ],
  },
  {
    title: "Administration",
    items: [
      ["staff-email", "Staff email"],
      ["access", "Customer access"],
      ["settings", "Settings"],
    ],
  },
] as const;
export const adminNavItems = adminNavGroups.flatMap((group) =>
  group.items.map(([key, label]): [string, string] => [key, label]),
);

function NavigationGroup({
  group,
  section,
  onNavigate,
  inquiries,
}: {
  group: (typeof adminNavGroups)[number];
  section: string;
  onNavigate: (section: string) => void;
  inquiries: number;
}) {
  const active =
    group.items.some(([key]) => key === section) ||
    (section === "account" && group.title === "Customers & orders");
  const [open, setOpen] = useState(active || group.title === "Overview");
  useEffect(() => {
    if (active) setOpen(true);
  }, [active, section]);
  return (
    <details
      className="cr-nav-group"
      open={open}
      onToggle={(event) => setOpen(event.currentTarget.open)}
    >
      <summary>
        {group.title}
        {group.title === "Customers & orders" && inquiries > 0 && (
          <span
            className="cr-nav-count"
            aria-label={`${inquiries} new service inquiries`}
          >
            {inquiries}
          </span>
        )}
      </summary>
      <div className="cr-nav-submenu">
        {group.items.map(([key, label]) => {
          const current =
            section === key
              ? "page"
              : section === "account" && key === "customers"
                ? "location"
                : undefined;
          return (
            <button
              key={key}
              className={current ? "active" : ""}
              aria-current={current}
              onClick={() => onNavigate(key)}
            >
              {label}
              {key === "inbox" && inquiries > 0 && <span>{inquiries}</span>}
            </button>
          );
        })}
      </div>
    </details>
  );
}
export function AdminNavigation({
  section,
  onNavigate,
  inquiries,
}: {
  section: string;
  onNavigate: (section: string) => void;
  inquiries: number;
}) {
  return (
    <div className="cr-admin-nav">
      {adminNavGroups.map((group) => (
        <NavigationGroup
          key={group.title}
          group={group}
          section={section}
          onNavigate={onNavigate}
          inquiries={inquiries}
        />
      ))}
    </div>
  );
}
